import { bl_fi_tax_filing_link_RowClass } from '../../../dbschema';
import {BaseContainerModel} from '../../base-container.model';

export class FilingLinkMainModel extends BaseContainerModel{
    bl_fi_tax_filing_link: bl_fi_tax_filing_link_RowClass = new bl_fi_tax_filing_link_RowClass();
  }